import React, { useState } from "react"
import { authStore } from "../utils/AuthStore"
import { Form, Input, Button, Alert, Card } from "antd"
import { useNavigate } from "react-router-dom"

const Login = () => {
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [verificationCode, setVerificationCode] = useState()
	const [errorMessage, setErrorMessage] = useState("")
	const [updatePassword, setUpdatePassword] = useState(false)
	const [forgotPassword, setForgotPassword] = useState(false)
	const [forgotPasswordFinish, setForgotPasswordFinish] = useState(false)

	let navigate = useNavigate()

	const onFinish = (values) => {
		let { newPassword } = values

		setErrorMessage("")

		if (forgotPassword) {
			authStore.forgotPassword(email)
			setForgotPassword(false)
			setForgotPasswordFinish(true)
			setUpdatePassword(true)
		} else if (forgotPasswordFinish) {
			authStore
				.confirmPassword(email, newPassword, verificationCode)
				.then(() => {
					setForgotPasswordFinish(false)
					setUpdatePassword(false)
				})
				.catch((err) => {
					if (err.code === "CodeMismatchException") setErrorMessage("The verification code entered is invalid")
				})
		} else {
			authStore
				.authenticate(email, password, newPassword)
				.then(() => navigate("/dashboard"))
				.catch((err) => {
					if (err.code === "NotAuthorizedException") setErrorMessage("The email or password entered is invalid")
					else if (err.code === "newPasswordRequired") setUpdatePassword(true)
				})
		}
	}

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo)
	}

	return (
		<div style={{ width: 600, margin: "60px auto 0" }}>
			{errorMessage.length > 0 && <Alert style={{ marginBottom: 20 }} message={errorMessage} type="error" closable />}

			<Card title="ICDD Admin Dashboard" style={{ margin: 20 }}>
				<Form
					name="basic"
					labelCol={{ span: 10 }}
					wrapperCol={{ span: 16 }}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete="off"
				>
					{!updatePassword && !forgotPassword && (
						<>
							<Form.Item label="Email" name="email" rules={[{ required: true, message: "Please input your email!" }]}>
								<Input onChange={(d) => setEmail(d.target.value)} />
							</Form.Item>

							<Form.Item
								label="Password"
								name="password"
								rules={[{ required: true, message: "Please input your password!" }]}
							>
								<Input.Password onChange={(d) => setPassword(d.target.value)} />
							</Form.Item>
						</>
					)}

					{forgotPassword && (
						<>
							<Form.Item label="Email" name="email" rules={[{ required: true, message: "Please input your email!" }]}>
								<Input onChange={(d) => setEmail(d.target.value)} />
							</Form.Item>
						</>
					)}

					{forgotPasswordFinish && (
						<>
							<Form.Item
								label="Verification Code"
								name="verificationCode"
								rules={[{ required: true, message: "Verification code required" }]}
							>
								<Input onChange={(d) => setVerificationCode(d.target.value)} />
							</Form.Item>
						</>
					)}

					{updatePassword && (
						<>
							<Form.Item
								label="New Password"
								name="newPassword"
								rules={[
									{ required: true, message: "Password required." },
									() => ({
										validator(_, value) {
											if (!value || value.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}$/)) {
												return Promise.resolve()
											}
											return Promise.reject(
												new Error(
													"Password must contain at least 8 characters including 1 uppercase,1 number and 1 special character (!@#$%^*&)."
												)
											)
										},
									}),
								]}
							>
								<Input.Password />
							</Form.Item>

							<Form.Item
								label="Confirm Password"
								name="confirmPassword"
								dependencies={["newPassword"]}
								rules={[
									{
										required: true,
										message: "Please confirm your password!",
									},
									({ getFieldValue }) => ({
										validator(_, value) {
											if (!value || getFieldValue("newPassword") === value) {
												return Promise.resolve()
											}
											return Promise.reject(new Error("The two passwords that you entered do not match."))
										},
									}),
								]}
							>
								<Input.Password />
							</Form.Item>
						</>
					)}

					<Form.Item wrapperCol={{ offset: 10, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>

						{!updatePassword && (
							<Button style={{ float: "right" }} type="link" onClick={() => setForgotPassword(!forgotPassword)}>
								{forgotPassword ? "Login" : "Forgot Password"}
							</Button>
						)}
					</Form.Item>
				</Form>
			</Card>
		</div>
	)
}

export default Login
